module.exports = __webpack_public_path__ + "img/weddings_05_H.bcbf90b5.webp";